<div class="row row--gutter">
  <div class="col-sm-12">

    <div class="card ad-model-container mb-0">

      <div class="ad-model-header d-flex justify-content-between align-items-center">
        <h5 class="mb-0">Ordering partner map&nbsp; <br><span
            class="vendor-name text-first-letter">({{orderingPartnerData.fullName}})</span></h5>

        <div class="d-flex justify-content-center align-items-center">
          <button type="button" class="close ml-4" data-dismiss="modal" (click)="closeModal()">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>

      </div>

      <div *ngIf="orderingPartnerShow && orderingPartnerList.length">

        <div *ngFor="let op of orderingPartnerList; let i=index">
          <div class="row">
            <div class="col-12">
              <div class="card ad-order-partner-container">
                <div class="ad-partner-header d-flex justify-content-start align-items-center">
                  <h6 class="mb-0 ellipsis-wrapped">{{op?.OrderingPartner?.full_name}}</h6>
                </div>

                <div class="d-flex justify-content-start align-items-center ad-order-partner-inner">
                  <div class="ad-partner-wrapper d-flex justify-content-end align-items-center">
                    <div class="ad-timer-container d-flex justify-content-center align-items-center">
                      <!-- <small class="mr-2">Waiting time (mins)</small> -->
                      <input type="text" class="form-control" [(ngModel)]="op.partner_merchant_id"
                        value="{{op.partner_merchant_id}}">
                    </div>
                  </div>  
                  <div class="ad-partner-wrapper d-flex justify-content-end align-items-center">
                    <div class="ad-status-container">
                      <div class="media custom--switch">
                        <div class="media-body icon-state">
                          <label class="switch">
                            <input type="checkbox" id="checkbox{{i}}" (change)="activeAndInactive($event,i,op)"
                              [checked]="op.status=='Active'?true:false" /><span class="switch-state"></span>
                          </label>
                        </div>
                        <label for="test" class="col-form-label m-l-10">Active</label>
                      </div>
                    </div>
                  </div>  
                  <div class="ad-drag-drop">
                    <button type="button" class="btn btn-primary" (click)="editFunction(op,i)">Update</button>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>

        <div class="d-flex justify-content-center align-items-center flex-column" *ngIf="!orderingPartnerList.length">
          <img src="assets/images/no-delivery-partner.png" alt="no-delivery-partner">
          <p class="mt-3 mb-1">There is no delivery partners</p>
          <a class="mr-2 cursor-pointer d-flex justify-content-center align-items-center"
            (click)="orderingPartnerAdd()">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="18" height="18" fill="#229cd9">
              <path fill="none" d="M0 0h24v24H0z" />
              <path d="M11 11V5h2v6h6v2h-6v6h-2v-6H5v-2z" />
            </svg> Add delivery partners</a>
        </div>

      </div>

      <div class="card-footer text-right" *ngIf="orderingPartnerShow">
        <button type="button" class="btn btn-secondary" (click)="orderingPartnerAdd()">Add</button>
      </div>

      <form [formGroup]="opFormGroup" (ngSubmit)="addOrderingPartner()">
        <div class="row mb-3 mt-3" *ngIf="!orderingPartnerShow">
          <div class="col">
            <div class="form-group">
              <label class="control-label">Ordering partner<span class="required">*</span></label>
              <ng-select class="custom-select" bindLabel="full_name" bindValue="user_id" placeholder="Select"
                formControlName="ordering_partner_user_id" [searchable]="true" [items]="orderingPartners">
              </ng-select>
              <div *ngIf="opFormGroup.get('ordering_partner_user_id').invalid && submitted" class="error">
                <p class="mb-0 text-danger">Please choose Ordering partner</p>
              </div>
            </div>
          </div>
          <div class="col">
            <div class="form-group">
              <label class="control-label">Partner merchant id<span class="required">*</span></label>
              <input class="form-control" id="order-time" placeholder="Enter merchant id"
                formControlName="partner_merchant_id" type="text">
              <div *ngIf="opFormGroup.get('partner_merchant_id').invalid && submitted" class="error">
                <p class="mb-0 text-danger">Merchant id is required</p>
              </div>
            </div>
          </div>
        </div>
        <div class="card-footer text-right" *ngIf="!orderingPartnerShow">
          <button type="button" class="btn btn-primary mr-2" (click)="backBtn()">Back</button>
          <button type="submit" class="btn btn-secondary">Save</button>
        </div>
      </form>

    </div>
  </div>
</div>